import React, {FC} from "react"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage from "@irati/utils/lang"

import {PopularWrapper, Popular, StyledH6} from "./styled"

const Recommended: FC = () => {
  const theme = useTheme()
  return (
    <PopularWrapper>
      <Popular>
        <Flex paddingTop={0.5} direction="column" justifyContent="space-between" alignItems="center" paddingLeft={theme.spacing.two}>
          <Icon icon={IconTypes.starFill} color={theme.colors.primary2} />
          <Flex alignItems="center">
            <StyledH6 color={theme.colors.primary2}>
              <FormattedMessage id="admin.components.modalWidget.recommended" />
            </StyledH6>
          </Flex>
        </Flex>
      </Popular>
    </PopularWrapper>
  )
}

export default Recommended
